import { useCallback } from 'react'

import useApi from 'lib/effects/api'
import useApiHelpers from 'lib/effects/api-helpers'

const useInvoices = () => {
  const {
    items: invoices,
    fetchItems: fetchInvoices,
    isFetching: isFetchingInvoices,
    createItem: createInvoice,
    isCreating: isCreatingInvoice,
    updateItem: updateInvoice,
    isUpdating: isUpdatingInvoice,
    deleteItem: deleteInvoice,
    isDeleting: isDeletingInvoice,
  } = useApiHelpers({
    baseUrl: `/api/invoices`,
    type: 'invoices',
  })

  const [
    { isLoading: isUpdatingLineItem, errors: updateLineItemErrors },
    patchLineItem,
  ] = useApi()

  const updateLineItem = useCallback(
    (lineItem, attributes) => {
      patchLineItem({
        url: `/api/invoices/${lineItem.invoiceId}/line-items/${lineItem.id}`,
        method: 'PATCH',
        data: {
          data: { type: 'invoice_line_items', id: lineItem.id, attributes },
        },
      })
    },
    [patchLineItem]
  )

  return {
    invoices,
    fetchInvoices,
    isFetchingInvoices,
    createInvoice,
    isCreatingInvoice,
    deleteInvoice,
    isDeletingInvoice,
    updateInvoice,
    isUpdatingInvoice,
    updateLineItem,
    isUpdatingLineItem,
    updateLineItemErrors,
  }
}

export default useInvoices
